function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 13v5.7c1.4-2.5 4-4.4 7-4.7-.4 4.2-3.8 7.6-8 8-4.2-.4-7.6-3.8-8-8 3 .3 5.6 2.2 7 4.7V13c-2.3-.6-4-2.6-4-5h4.2H7V4c0-.6.3-.7.6-.2l2 2.2 1.8-2.2c.3-.5 1-.5 1.2 0l2 2.2 1.8-2.2c.3-.5.6-.4.6.2v4h-4 4c0 2.4-1.7 4.4-4 5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationGarden = function SvgLocationGarden(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationGarden;